import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, History, Plus, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface HistoryPageHeaderProps {
  isLoading: boolean;
  onBack: () => void;
  onRefresh: () => void;
  onNewAnalysis: () => void;
}

const HistoryPageHeader: React.FC<HistoryPageHeaderProps> = ({
  isLoading,
  onBack,
  onRefresh,
  onNewAnalysis,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex min-w-0 items-center gap-4">
        <Button
          variant="ghost"
          size="icon-lg"
          aria-label={t('drbfm.history.back', 'DRBFMへ戻る')}
          onClick={onBack}
        >
          <ArrowLeft strokeWidth={1.9} />
        </Button>
        <History className="size-8 shrink-0 text-primary" strokeWidth={1.6} aria-hidden="true" />
        <h1 className="revy-cjk min-w-0 text-2xl font-semibold leading-[1.4] tracking-tight">
          {t('drbfm.history.title', '分析履歴')}
        </h1>
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onRefresh} disabled={isLoading}>
          <RefreshCw strokeWidth={1.9} />
          <span className="revy-cjk">{t('common.refresh', '更新')}</span>
        </Button>
        <Button onClick={onNewAnalysis}>
          <Plus strokeWidth={1.9} />
          <span className="revy-cjk">{t('drbfm.history.newAnalysis', '新規分析')}</span>
        </Button>
      </div>
    </div>
  );
};

export default HistoryPageHeader;
